import { render, staticRenderFns } from "./NewPackageSection.vue?vue&type=template&id=f5fc6b46&"
import script from "./NewPackageSection.vue?vue&type=script&lang=js&"
export * from "./NewPackageSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports